<template>
  <div>
    <p v-if="refreshTime">动画间隔时间</p>
    <slider-and-input
      class="mt8"
      v-if="refreshTime"
      :value.sync="refreshTime"
      title=""
      :sliderMax="3600"
      :sliderMin="3"
      inputWidth="large"
      inputHeight="small"
      suffix="秒"
      titlePosition="singleLine"
    />
    <p class="mt16" v-if="chartAnimationDuration">动画持续时间</p>
    <slider-and-input
      class="mt8"
      :value.sync="chartAnimationDuration"
      title=""
      :sliderMax="100"
      :sliderMin="1"
      inputWidth="large"
      inputHeight="small"
      suffix="秒"
      titlePosition="singleLine"
    />
  </div>
</template>

<script>
import publicData from "./publicData"
export default {
  mixins: [publicData],
  props: {
    options: {
      type: Object
    },
    ids: {
      type: Object
    }
  },
  data() {
    return {
      this1: this
    }
  },
  computed: {
    chartOpt() {
      return this.options.chartOption
    },
    refreshTime: {
      get() {
        return this.checkAndSetPrimaryVal(this.chartOpt, "refreshTime", "refreshTime", 1) / 1000
      },
      set(newVal) {
        if (newVal !== null) {
          this.$changeOptionsEV(newVal * 1000, "chartOption.refreshTime", false)
        }
      }
    },
    chartAnimationDuration: {
      get() {
        return this.hasProperty(this.chartOpt, "animationDuration") / 1000
      },
      set(newVal) {
        this.$changeOptionsEV(newVal * 1000, "chartOption.animationDuration", false)
        this.$changeOptionsEV(newVal * 1000, "chartOption.animationDurationUpdate", false)
      }
    }
  }
}
</script>

<style></style>
